export default __webpack_public_path__ + "615253641b0bf582269ab69424ec29cd.png";